
import { EnvProd } from "./environment.prod"
// import { EnvLocal } from "./environment.local"

const env = EnvProd;

export const ENV = {
    api: env.api,
    bucket: env.firebase.bucket
}